import React from "react";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // You can log the error to a logging service if needed
    console.error("Error caught by ErrorBoundary:", error, info);
  }

  handleGoBack = () => {
    // ✅ Go back one page in browser history
    if (window.history.length > 1) {
      window.history.back(); // or use go(-1) or go(-2) for further
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } else {
      // Fallback if there's no history
      window.location.href = "/";
    }
  };

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      return (
        <div style={{ display:"flex", flexDirection:'column',justifyContent:'center',alignItems:'center', height:"100vh" ,gap:"8px"}}>
          <ErrorOutlineIcon style={{width:"72px", height:"72px"}} />
          <h1>{this.props.t('ERROR_HEADING')}</h1>
          <p style={{ paddingTop: "10px" }}>{this.props.t('ERROR_MESSAGE')}</p>
          {/* <p>{this.state.error?.message}</p> */}
          <button onClick={this.handleGoBack} style={{ padding: '10px 20px',marginTop:"5px", borderRadius: "5px", cursor: 'pointer', background: "var(--bs-blue)", border: "none", color: "#fff", fontWeight: "bold", fontSize:"17px" }}>
            {this.props.t('ERROR_BUTTON')}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
